import { useState, useEffect, useCallback } from 'react';

const useGoogle = () => {
    const [tokenClient, setTokenClient] = useState(null);

    const handleCredentialResponse = useCallback((response) => {
        // This callback is for Sign In With Google, which we aren't using for this flow.
        // We are using the token client for more granular scope control.
        console.log("Encoded JWT ID token: " + response.credential);
    }, []);

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            if (!process.env.REACT_APP_GOOGLE_CLIENT_ID) {
                console.error('REACT_APP_GOOGLE_CLIENT_ID is not defined in .env');
                return;
            }

            // Initialize the Google Identity Services client
            window.google.accounts.id.initialize({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                callback: handleCredentialResponse,
                use_fedcm_for_prompt: false, // Explicitly disabling FedCM as per your suggestion
            });

            // Initialize the OAuth 2.0 Token Client
            const client = window.google.accounts.oauth2.initTokenClient({
                client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
                scope: 'https://www.googleapis.com/auth/drive.file',
                callback: '', // Callback is handled by the promise in requestAccessToken
            });
            setTokenClient(client);
        };
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, [handleCredentialResponse]);

    const requestAccessToken = () => {
        return new Promise((resolve, reject) => {
            if (!tokenClient) {
                reject("Token client not initialized.");
                return;
            }

            try {
                tokenClient.callback = (tokenResponse) => {
                    if (tokenResponse && tokenResponse.access_token) {
                        resolve(tokenResponse.access_token);
                    } else {
                        // This can happen if the user closes the popup.
                        reject("Access token request was denied or failed.");
                    }
                };
                tokenClient.requestAccessToken();
            } catch (error) {
                reject(error);
            }
        });
    };

    return {
        isGoogleReady: !!tokenClient,
        requestAccessToken,
    };
};

export default useGoogle;
